import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import {SocItem} from "../../domain/SocItem";
import {SectionProps} from "./SectionProps";
import {Controller, useWatch} from "react-hook-form";
import {fieldLabels} from "./fieldLabels";
import {Error} from "../common/Error";
import {TextField} from "@ofqual/portal-components/components/TextField";

export const ThirdPartyArrangements: React.FC<SectionProps<SocItem>> = (
  sectionProps
) => {
  const {control, disabled, errors} = sectionProps;

  const {thirdPartyArrangement, sharedOperationFinance} = useWatch<SocItem>({
    control,
    name: ["thirdPartyArrangement", "sharedOperationFinance"],
  });

  //   const { thirdPartyArrangement, sharedOperationFinance } = useWatch<SocItem>({
  //     control,
  //     name: ["thirdPartyArrangement, sharedOperationFinance"],
  //   });
  console.log('Errors : ', errors);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="body1">
          These questions are about any arrangements that you have in place with
          third parties that directly support you in your development, delivery,
          and award of qualifications. For example:
        </Typography>
        <ul>
          <li>
            <Typography>examiners and Centres,</Typography>
          </li>
          <li>
            <Typography>couriers transporting exam scripts,</Typography>
          </li>
          <li>
            <Typography>
              IT platform providers for the purposes of registering and
              certificating learners,
            </Typography>
          </li>
          <li>
            <Typography>
              providers of online marking software or remote invigilation
              software,
            </Typography>
          </li>
          <li>
            <Typography>facilities to scan exam scripts.</Typography>
          </li>
        </ul>
        <Typography variant="body1">
          We do not require details of your arrangements with those providers
          that do not support you directly with the development, delivery, or
          award of your qualifications. For example, you do not need to include
          details of how you work with any third parties you use to support your
          HR functions or office building maintenance.{" "}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">
          Monitoring and enforcement of arrangements with third parties who
          support you in the development, delivery, and award of qualifications
        </Typography>

        <Controller
          control={control}
          name="thirdPartyArrangement"
          rules={{validate: (value) => value !== null}}
          render={(props) => (
            <FormControl component="fieldset" required disabled={disabled}>
              <FormLabel id="thirdPartyArrangement-label" component="legend">
                {fieldLabels.thirdPartyArrangement}
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="thirdPartyArrangement-label"
                name="thirdPartyArrangement"
                data-test="radiogroup-thirdPartyArrangement"
                onChange={(e) => props.onChange(e.target.value === "true")}
              >
                <FormControlLabel
                  value={true}
                  label="Yes"
                  control={<Radio/>}
                  data-test="thirdPartyArrangement-yes"
                  checked={props.value === true}
                />
                <FormControlLabel
                  value={false}
                  label="No"
                  control={<Radio/>}
                  data-test="thirdPartyArrangement-no"
                  checked={props.value === false}
                />
              </RadioGroup>
            </FormControl>
          )}
        />
        {errors.thirdPartyArrangement && (
          <>
            <br></br>
            <Error data-test="thirdPartyArrangement-validation">
              You must select at least one option
            </Error>
          </>
        )}
      </Grid>

      {thirdPartyArrangement ? (
        <>
          <Grid item xs={12} sm={12}>
            <Controller
              control={control}
              rules={{maxLength: 5000, required: true}}
              name="thirdPartyArrangementNatureSummary"
              as={
                <TextField
                  label={fieldLabels.thirdPartyArrangementNatureSummary}
                  readOnly={disabled}
                  data-test="thirdPartyArrangementNatureSummary-field"
                  rows={8}
                  multiline
                  required
                />
              }
            />
            {errors.thirdPartyArrangementNatureSummary?.type ===
              "maxLength" && (
                <Error data-test="thirdPartyArrangementNatureSummary-validation">
                  Must be no more than 5,000 characters
                </Error>
              )}
            {errors.thirdPartyArrangementNatureSummary?.type === "required" && (
              <Error data-test="thirdPartyArrangementNatureSummary-validation">
                This field is required
              </Error>
            )}
          </Grid>
          <Grid item xs={12} sm={12}>
            <Controller
              control={control}
              rules={{maxLength: 5000, required: true}}
              name="thirdPartyComplySummary"
              as={
                <TextField
                  label={fieldLabels.thirdPartyComplySummary}
                  readOnly={disabled}
                  data-test="thirdPartyComplySummary-field"
                  rows={8}
                  multiline
                  required
                />
              }
            />
            {errors.thirdPartyComplySummary?.type === "maxLength" && (
              <Error data-test="thirdPartyComplySummary-validation">
                Must be no more than 5,000 characters
              </Error>
            )}
            {errors.thirdPartyComplySummary?.type === "required" && (
              <Error data-test="thirdPartyComplySummary-validation">
                This field is required
              </Error>
            )}
          </Grid>
          <Grid item xs={12} sm={12}>
            <Controller
              control={control}
              rules={{maxLength: 5000, required: true}}
              name="thirdPartyExpectation"
              as={
                <TextField
                  label={fieldLabels.thirdPartyExpectation}
                  readOnly={disabled}
                  data-test="thirdPartyExpectation-field"
                  rows={8}
                  multiline
                  required
                />
              }
            />
            {errors.thirdPartyExpectation?.type === "maxLength" && (
              <Error data-test="thirdPartyExpectation-validation">
                Must be no more than 5,000 characters
              </Error>
            )}
            {errors.thirdPartyExpectation?.type === "required" && (
              <Error data-test="thirdPartyExpectation-validation">
                This field is required
              </Error>
            )}
          </Grid>
          <Grid item xs={12} sm={12}>
            <Typography variant="body1">
              How do you monitor and enforce your arrangements with third
              parties? What are your processes to:
            </Typography>
            <Grid item xs={12}>
              <Grid item xs={12} sm={12}>
                <Controller
                  control={control}
                  rules={{maxLength: 5000, required: true}}
                  name="thirdPartyMonitorContingency"
                  as={
                    <TextField
                      label={fieldLabels.thirdPartyMonitorContingency}
                      readOnly={disabled}
                      data-test="thirdPartyMonitorContingency-field"
                      rows={4}
                      multiline
                      required
                    />
                  }
                />
                {errors.thirdPartyMonitorContingency?.type === "maxLength" && (
                  <Error data-test="thirdPartyMonitorContingency-validation">
                    Must be no more than 5,000 characters
                  </Error>
                )}
                {errors.thirdPartyMonitorContingency?.type === "required" && (
                  <Error data-test="thirdPartyMonitorContingency-validation">
                    This field is required
                  </Error>
                )}
              </Grid>
              <br/>
              <Grid item xs={12} sm={12}>
                <Controller
                  control={control}
                  rules={{maxLength: 5000, required: true}}
                  name="thirdPartyMonitorContinuity"
                  as={
                    <TextField
                      label={fieldLabels.thirdPartyMonitorContinuity}
                      readOnly={disabled}
                      data-test="thirdPartyMonitorContinuity-field"
                      rows={4}
                      multiline
                      required
                    />
                  }
                />
                {errors.thirdPartyMonitorContinuity?.type === "maxLength" && (
                  <Error data-test="thirdPartyMonitorContinuity-validation">
                    Must be no more than 5,000 characters
                  </Error>
                )}
                {errors.thirdPartyMonitorContinuity?.type === "required" && (
                  <Error data-test="thirdPartyMonitorContinuity-validation">
                    This field is required
                  </Error>
                )}
              </Grid>
              <br/>
              <Grid item xs={12} sm={12}>
                <Controller
                  control={control}
                  rules={{maxLength: 5000, required: true}}
                  name="thirdPartyMonitorBreach"
                  as={
                    <TextField
                      label={fieldLabels.thirdPartyMonitorBreach}
                      readOnly={disabled}
                      data-test="thirdPartyMonitorBreach-field"
                      rows={4}
                      multiline
                      required
                    />
                  }
                />
                {errors.thirdPartyMonitorBreach?.type === "maxLength" && (
                  <Error data-test="thirdPartyMonitorBreach-validation">
                    Must be no more than 5,000 characters
                  </Error>
                )}
                {errors.thirdPartyMonitorBreach?.type === "required" && (
                  <Error data-test="thirdPartyMonitorBreach-validation">
                    This field is required
                  </Error>
                )}
              </Grid>
              <br/>
              <Grid item xs={12} sm={12}>
                <Controller
                  control={control}
                  rules={{maxLength: 5000, required: true}}
                  name="thirdPartyMonitorPerformance"
                  as={
                    <TextField
                      label={fieldLabels.thirdPartyMonitorPerformance}
                      readOnly={disabled}
                      data-test="thirdPartyMonitorPerformance-field"
                      rows={4}
                      multiline
                      required
                    />
                  }
                />
                {errors.thirdPartyMonitorPerformance?.type === "maxLength" && (
                  <Error data-test="thirdPartyMonitorPerformance-validation">
                    Must be no more than 5,000 characters
                  </Error>
                )}
                {errors.thirdPartyMonitorPerformance?.type === "required" && (
                  <Error data-test="thirdPartyMonitorPerformance-validation">
                    This field is required
                  </Error>
                )}
              </Grid>

            </Grid>
          </Grid>
        </>
      ) : thirdPartyArrangement !== null ? (
        <>
          <Grid item xs={12} sm={12}>
            <Controller
              control={control}
              rules={{maxLength: 5000, required: true}}
              name="thirdPartyInHouseSummary"
              as={
                <TextField
                  label={fieldLabels.thirdPartyInHouseSummary}
                  readOnly={disabled}
                  data-test="thirdPartyInHouseSummary-field"
                  rows={8}
                  multiline
                  required
                />
              }
            />
            {errors.thirdPartyInHouseSummary?.type === "maxLength" && (
              <Error data-test="thirdPartyInHouseSummary-validation">
                Must be no more than 5,000 characters
              </Error>
            )}
            {errors.thirdPartyInHouseSummary?.type === "required" && (
              <Error data-test="thirdPartyInHouseSummary-validation">
                This field is required
              </Error>
            )}
          </Grid>
        </>
      ) : null}

      <Grid item xs={12}>
        <Typography variant="h6">Conflicts of interest</Typography>
        <Controller
          control={control}
          name="sharedOperationFinance"
          rules={{validate: (value) => value !== null}}
          render={(props) => (
            <FormControl component="fieldset" required disabled={disabled}>
              <FormLabel id="sharedOperationFinance-label" component="legend">
                {fieldLabels.sharedOperationFinance}
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="sharedOperationFinance-label"
                name="sharedOperationFinance"
                data-test="radiogroup-sharedOperationFinance"
                onChange={(e) => props.onChange(e.target.value === "true")}
              >
                <FormControlLabel
                  value={true}
                  label="Yes"
                  control={<Radio/>}
                  data-test="sharedOperationFinance-yes"
                  checked={props.value === true}
                />
                <FormControlLabel
                  value={false}
                  label="No"
                  control={<Radio/>}
                  data-test="sharedOperationFinance-no"
                  checked={props.value === false}
                />
              </RadioGroup>
            </FormControl>
          )}
        />
        {errors.sharedOperationFinance && (
          <>
            <br></br>
            <Error data-test="sharedOperationFinance-validation">
              You must select at least one option
            </Error>
          </>
        )}
      </Grid>
      {sharedOperationFinance && (
        <Grid item xs={12} sm={12}>
          <Controller
            control={control}
            rules={{maxLength: 5000, required: true}}
            name="conflictOfInterestIdentification"
            as={
              <TextField
                label={fieldLabels.conflictOfInterestIdentification}
                readOnly={disabled}
                data-test="conflictOfInterestIdentification-field"
                rows={8}
                multiline
                required
              />
            }
          />
          {errors.conflictOfInterestIdentification?.type === "maxLength" && (
            <Error data-test="conflictOfInterestIdentification-validation">
              Must be no more than 5,000 characters
            </Error>
          )}
          {errors.conflictOfInterestIdentification?.type === "required" && (
            <Error data-test="conflictOfInterestIdentification-validation">
              This field is required
            </Error>
          )}
        </Grid>
      )}
    </Grid>
  );
};
